var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 27.3332C30.7337 27.3332 31.3337 26.7332 31.3337 25.9998C31.3337 25.2665 30.7337 24.6665 30.0003 24.6665C29.267 24.6665 28.667 25.2665 28.667 25.9998C28.667 26.7332 29.267 27.3332 30.0003 27.3332ZM30.0003 28.6665C29.267 28.6665 28.667 29.2665 28.667 29.9998C28.667 30.7332 29.267 31.3332 30.0003 31.3332C30.7337 31.3332 31.3337 30.7332 31.3337 29.9998C31.3337 29.2665 30.7337 28.6665 30.0003 28.6665ZM30.0003 32.6665C29.267 32.6665 28.667 33.2665 28.667 33.9998C28.667 34.7332 29.267 35.3332 30.0003 35.3332C30.7337 35.3332 31.3337 34.7332 31.3337 33.9998C31.3337 33.2665 30.7337 32.6665 30.0003 32.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.aaec97837a1fa5242029b1bfee8ddff7.svg";
export { ForwardRef as ReactComponent };